import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getActivityProduct, updateActivityPouduct } from '@/services/marketing/activity';
import Cookie from 'js-cookie';
import { Tree } from 'ant-design-vue';
import { TreeSelect } from 'ant-design-vue';
import FooterToolBar from '@/components/tool/FooterToolBar';
import importfailed from '@/components/importfailed/index';
import selectProduct from '@/components/commonAdd/selectGroupGoods.vue';
export default {
  name: 'ActivityProduct',
  i18n: require('./i18n-activity'),
  components: {
    TreeSelect: TreeSelect,
    Tree: Tree,
    FooterToolBar: FooterToolBar,
    importfailed: importfailed,
    selectProduct: selectProduct
  },
  props: {
    activityId: {
      type: Number,
      default: null
    },
    lookinfo: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    var _this = this;
    var buyLimitNumValidatePass = function buyLimitNumValidatePass(rule, value, callback) {
      if (_this.chooseproductparam.buyLimit === 1 && (_this.chooseproductparam.buyLimitNum === '' || _this.chooseproductparam.buyLimitNum === null)) {
        //请输入
        callback(new Error(_this.$t('activity.limitprop')));
      } else {
        callback();
      }
    };
    var propnumberValidatePass = function propnumberValidatePass(rule, value, callback) {
      if (_this.modalValue.productNum === '' || _this.modalValue.productNum === null || _this.modalValue.productNum === 0) {
        //请输入参与件数
        callback(new Error(_this.$t('activity.propnumber')));
      } else {
        callback();
      }
    };
    var activityContentValidatePass = function activityContentValidatePass(rule, value, callback) {
      if (_this.chooseproductparam.activityContent === '' || _this.chooseproductparam.activityContent === null || _this.chooseproductparam.activityContent === 0) {
        //请输入参与件数
        callback(new Error(_this.$t('activity.discountprop')));
      } else {
        callback();
      }
    };
    var columns1 = [{
      title: this.$t('publicuse.goodsno'),
      dataIndex: 'productNo',
      key: 'productNo',
      width: '20%',
      align: 'left'
    }, {
      dataIndex: 'goodsName',
      title: this.$t('publicuse.goodsname'),
      key: 'goodsName',
      width: '40%',
      scopedSlots: {
        customRender: 'goodsName' //自定义表格里面的内容
      },
      ellipsis: true,
      align: 'left'
    },
    // {
    // 	title: this.$t('publicuse.status'),
    // 	dataIndex: 'productStatus',
    // 	key: 'productStatus',
    // 	width: '100px',
    // 	className: 'status-class',
    // 	scopedSlots: {
    // 		customRender: 'product-status', //自定义表格里面的内容
    // 	},
    // 	defaultSortOrder: 'ascend',
    // 	sorter: (a, b) => a.productStatus - b.productStatus,
    // 	sortOrder: sortedInfo.columnKey === 'productStatus' && sortedInfo.order
    // }, 
    {
      title: this.$t('publicuse.status'),
      dataIndex: 'status',
      key: 'status',
      width: '20%',
      align: 'center',
      scopedSlots: {
        customRender: 'status'
      }
    }, {
      title: this.$t('activity.inventoryquantity'),
      dataIndex: 'productStockNum',
      key: 'productStockNum',
      width: '20%',
      scopedSlots: {
        customRender: 'productStockNum'
      },
      align: 'right'
    }, {
      title: this.$t('publicuse.action'),
      dataIndex: 'action',
      key: 'action',
      width: '20%',
      scopedSlots: {
        customRender: 'action'
      },
      align: 'center'
    }];
    var columns2 = [{
      title: this.$t('publicuse.goodsno'),
      dataIndex: 'productNo',
      key: 'productNo',
      width: '20%',
      align: 'left'
    }, {
      dataIndex: 'goodsName',
      title: this.$t('publicuse.goodsname'),
      key: 'goodsName',
      width: '40%',
      scopedSlots: {
        customRender: 'goodsName' //自定义表格里面的内容
      },
      ellipsis: true,
      align: 'left'
    }, {
      title: this.$t('publicuse.status'),
      dataIndex: 'status',
      key: 'status',
      width: '20%',
      align: 'center',
      scopedSlots: {
        customRender: 'status'
      }
    }, {
      title: this.$t('activity.inventoryquantity'),
      dataIndex: 'productStocknum',
      key: 'productStocknum',
      width: '20%',
      align: 'right'
    }];
    return {
      selectedRowKeys: [],
      activityinfoparam: {},
      limitdis: true,
      productList: [],
      isTableLoading: false,
      yesAvailableList: [],
      notAvailableList: [],
      listTotal: 0,
      crrentPageProductList: [],
      chooseproductparam: {
        //商品类型
        productType: 1,
        //折扣
        activityContent: '',
        checkedKeys: [],
        //限购设置类型
        buyLimit: 0,
        //限购设置的数量
        buyLimitNum: ''
      },
      defaultLangObj: JSON.parse(localStorage.defaultLangObj),
      rightCurrencySymbol: localStorage.rightCurrencySymbol,
      leftCurrencySymbol: localStorage.leftCurrencySymbol,
      rangeRules: {
        activityContent: [{
          required: true,
          validator: activityContentValidatePass,
          // message: this.$t('activity.discountprop'),
          trigger: 'blur'
        }]
      },
      importObj: {},
      importVisible: false,
      files: '',
      newheaders: {
        headers: ''
      },
      action: process.env.VUE_APP_API_BASE_URL + "/activity/importGoods/",
      buttonType: 2,
      dialogStatus: '',
      textMap: {
        batchoff: this.$t('activity.batchoff'),
        batchnumber: this.$t('public.batchnumber'),
        batchinvalid: this.$t('batchDelete')
      },
      /* 弹框验证 */
      modalRules: {
        productNum: [{
          required: true,
          validator: propnumberValidatePass,
          // message: this.$t('activity.propnumber'),
          trigger: 'blur'
        }],
        discount: [{
          required: true,
          // validator: propnumberValidatePass,
          message: this.$t('activity.discountprop'),
          trigger: 'blur'
        }]
      },
      rules: {
        buyLimitNum: [{
          validator: buyLimitNumValidatePass,
          trigger: 'blur'
        }]
      },
      //如果有新增的商品存入的值
      addProductIds: [],
      //选中的商品list
      selectProductList: [],
      //失效的商品ids
      deleteProductIds: [],
      //新增的商品ids
      productIds: [],
      removeTypeVisible: false,
      modalValue: {
        removeType: 0,
        productNum: '',
        discount: ''
      },
      tableLoading: false,
      selectNumber: 0,
      queryParam: {
        page: 1,
        size: 5
      },
      updateLoading: false,
      datavalue: {
        name: '',
        total: ''
      },
      AllStatus: [],
      // 高级搜索 展开/关闭
      advanced: false,
      visible: false,
      addproductList: [],
      expandedKeys: ["0-1"],
      autoExpandParent: true,
      selectedKeys: [],
      commodityClassificationList: [],
      sortedInfo: {
        columnKey: 'productStatus',
        order: "ascend"
      },
      total: 0,
      addList: [],
      columns1: columns1,
      columns2: columns2,
      alreadySelect: [],
      saveList: [],
      originalList: [],
      pageList: [],
      originalMap: {}
    };
  },
  watch: {
    'selectProductList': function selectProductList() {
      // console.log(this.selectProductList)
      this.selectNumber = this.selectProductList.length;
    },
    'chooseproductparam.buyLimitNum': function chooseproductparamBuyLimitNum() {
      if (this.chooseproductparam.buyLimit == 1) {
        this.$refs.ruleForm.validateField(["buyLimitNum"]);
      } else {
        this.$refs.ruleForm.clearValidate(["buyLimitNum"]);
      }
    },
    'chooseproductparam.activityContent': function chooseproductparamActivityContent() {
      if (this.chooseproductparam.activityContent == '' || this.chooseproductparam.activityContent == 0) {
        this.$refs.rangeRuleForm.validateField(["activityContent"]);
      }
    }
  },
  activated: function activated() {
    this.newheaders = {
      "x-auth-token": Cookie.get("x-auth-token")
    };
  },
  created: function created() {
    this.newheaders = {
      "x-auth-token": Cookie.get("x-auth-token")
    };
    this.getList();
  },
  // computed: {
  // 	columns() {
  // 		let {
  // 			sortedInfo
  // 		} = this;
  // 		sortedInfo = sortedInfo || {};
  // 		const columns = [{
  // 					title: this.$t('publicuse.goodsno'),
  // 					dataIndex: 'goodsNumber',
  // 					key: 'goodsNumber',
  // 					width: '20%',
  // 					align: 'center',
  // 				}, {
  // 					dataIndex: 'goodsName',
  // 					title:this.$t('publicuse.goodsname'),
  // 					key: 'goodsName',
  // 					width: '40%',
  // 					scopedSlots: {
  // 						customRender: 'goodsName', //自定义表格里面的内容
  // 					},
  // 					ellipsis: true,
  // 					align: 'left',
  // 				},
  // 				// {
  // 				// 	title: this.$t('publicuse.status'),
  // 				// 	dataIndex: 'productStatus',
  // 				// 	key: 'productStatus',
  // 				// 	width: '100px',
  // 				// 	className: 'status-class',
  // 				// 	scopedSlots: {
  // 				// 		customRender: 'product-status', //自定义表格里面的内容
  // 				// 	},
  // 				// 	defaultSortOrder: 'ascend',
  // 				// 	sorter: (a, b) => a.productStatus - b.productStatus,
  // 				// 	sortOrder: sortedInfo.columnKey === 'productStatus' && sortedInfo.order
  // 				// }, 
  // 				{
  // 					title: this.$t('publicuse.status'),
  // 					dataIndex: 'status',
  // 					key: 'status',
  // 					width: '20%',
  // 					align: 'center',
  // 					scopedSlots: {
  // 						customRender: 'status',
  // 					},
  // 				}, 
  // 				// {
  // 				// 	title: this.$t('activity.inventoryquantity'),
  // 				// 	dataIndex: 'productStockNum',
  // 				// 	key: 'productStockNum',
  // 				// 	width: '20%',
  // 				// 	align: 'right'
  // 				// },
  // 				{
  // 					title: this.$t('publicuse.action'),
  // 					dataIndex: 'action',
  // 					key: 'action',
  // 					width: '20%',
  // 					scopedSlots: {
  // 						customRender: 'action',
  // 					},
  // 					align: 'center'
  // 				},
  // 			];
  // 			return columns;
  // 	}
  // },
  methods: {
    getList: function getList() {
      var _this2 = this;
      this.isTableLoading = true;
      getActivityProduct(this.activityId).then(function (response) {
        var productData = response.data.data;
        if (productData !== null) {
          _this2.chooseproductparam.productType = productData.productType;
          _this2.productList = productData.productList;
          _this2.saveList = _.cloneDeep(_this2.productList);
          _this2.originalList = _.cloneDeep(_this2.productList);
          _this2.originalMap = new Map();
          _this2.originalList.forEach(function (item, index, arr) {
            item.myindex = index;
            console.log(item);
            _this2.originalMap.set(item.optionId, item);
          });
          _this2.alreadySelect = _this2.productList.map(function (item) {
            return item.optionId;
          });
          // 	//初始肯定是第一页，那么需要截取第一页的数据
          _this2.crrentPageProductList = _this2.productList.slice(0, _this2.queryParam.size);
          _this2.listTotal = _this2.productList.length;
        }
      }).finally(function () {
        _this2.isTableLoading = false;
      });
    },
    /* 上一步 */prevStep: function prevStep() {
      this.$emit('prevStep');
    },
    /* 子组件关闭的方法 */getVisible: function getVisible(visible) {
      this.importVisible = visible;
    },
    handleChange: function handleChange(info) {
      var _this3 = this;
      var fileList = _toConsumableArray(info.fileList);
      var activityId = null;
      var productStatus = 0;
      if (this.chooseproductparam.productType == 2) {
        productStatus = 1;
      }
      fileList = fileList.slice(-1);
      if (fileList[0].response != undefined) {
        var newRes = fileList[0].response;
        if (newRes.code == 200) {
          //如果有导入失败的话，需要展示出导入失败的list
          if (newRes.failList.length > 0) {
            this.importVisible = true;
            this.importObj = {
              failList: newRes.failList,
              failNum: newRes.failNum,
              successList: newRes.successList,
              successNum: newRes.successNum
            };
          }
          //如果有导入成功的话，需要吧导入成功的list，添加到列表中
          //如果原来商品list中已经存在的，以商品list中为主
          var oldProductList = _.cloneDeep(this.productList);
          _.remove(newRes.successList, function (o) {
            return oldProductList.findIndex(function (item) {
              return item.productOptionId === o.productSpecId;
            }) !== -1; //o.productSpecId != oldItem.productOptionId;
          });
          console.log(newRes.successList);
          // oldProductList.forEach(oldItem => {
          // 	newRes.successList = _.remove(newRes.successList, function(o) {
          // 		return o.productSpecId != oldItem.productOptionId;
          // 	});
          // })
          if (newRes.successList.length > 0) {
            newRes.successList.forEach(function (item) {
              var newObj = {
                activityContent: '',
                activityId: activityId,
                id: null,
                lastUpdateTime: null,
                productName: item.goodsName,
                productNo: item.goodsNo,
                productNum: '',
                productOptionId: item.productSpecId,
                productOptionName: item.specName,
                productPrice: item.price,
                productStatus: productStatus,
                productStockNum: item.productStockNum,
                productId: item.productId
              };
              _this3.productList.push(newObj);
            });
            // let newproductList = _.cloneDeep(this.productList)
            this.crrentPageProductList = this.productList.slice((this.queryParam.page - 1) * this.queryParam.size, this.queryParam.size);
            console.log(this.crrentPageProductList, 'current');
            this.listTotal = this.productList.length;
            this.$message.success(this.$t("public.importsucceeded"));
          }
        } else {
          this.$message.error(this.$t("public.importfail"));
        }
      }
    },
    beforeUpload: function beforeUpload(file) {
      this.files = file;
      var extension = file.name.split('.')[1] === 'xls';
      var extension2 = file.name.split('.')[1] === 'xlsx';
      var isLt5M = file.size / 1024 / 1024 < 10;
      if (!extension && !extension2) {
        this.$message.error(this.$t("public.exportpromptone"));
        return false;
      }
      if (!isLt5M) {
        this.$message.error(this.$t("public.exportprompytwo"));
        return false;
      }
    },
    changelimit: function changelimit(type) {
      if (type == 0) {
        this.limitdis = true;
        this.chooseproductparam.buyLimitNum = '';
      } else {
        this.limitdis = false;
      }
    },
    onChange: function onChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      console.log(this.selectedRowKeys, 'selected.......');
    },
    onSelect: function onSelect(record, selected, selectedRows) {
      //如果选中，添加进去
      if (selected) {
        this.selectProductList = _.concat(this.selectProductList, record);
        console.log(this.selectProductList, '选中了');
      } else {
        console.log(record);
        console.log(this.selectProductList);
        //取消选中，失效
        this.selectProductList = _.remove(this.selectProductList, function (o) {
          return o.optionId != record.optionId;
        });
      }
    },
    onSelectAll: function onSelectAll(selected, selectedRows, changeRows) {
      var _this4 = this;
      if (selected) {
        this.selectProductList = _.concat(this.selectProductList, changeRows);
      } else {
        changeRows.forEach(function (item) {
          //取消选中，失效
          _this4.selectProductList = _.remove(_this4.selectProductList, function (o) {
            return o.optionId != item.optionId;
          });
        });
      }
    },
    /* 切换批量失效类型 */removeTypeChange: function removeTypeChange() {},
    removeModal: function removeModal() {
      var _this5 = this;
      //判断是 选择的值，还是 当前页，还是全部页
      var lodingData = [];
      console.log(this.modalValue.removeType);
      if (this.modalValue.removeType == 0) {
        lodingData = _.cloneDeep(this.selectProductList);
      } else if (this.modalValue.removeType == 1) {
        lodingData = _.cloneDeep(this.crrentPageProductList);
      } else {
        lodingData = _.cloneDeep(this.productList);
      }
      console.log(this.selectProductList, 'select');
      //移除 全部页删除 不用这样删除
      if (this.modalValue.removeType == 2) {
        this.saveList.forEach(function (item, index, arr) {
          arr[index].activityProductStatus = 1;
        });
        this.productList = [];
        this.alreadySelect = [];
        this.selectProductList = [];
      } else {
        lodingData.forEach(function (item) {
          _this5.saveList.forEach(function (item2, index, arr) {
            if (item2.optionId == item.optionId) {
              arr[index].activityProductStatus = 1;
            }
          });
          _this5.productList = _this5.saveList.filter(function (item) {
            return item.activityProductStatus == 0;
          });
          console.log(_this5.saveList, 'old...');
          _this5.alreadySelect = _this5.productList.map(function (item) {
            return item.optionId;
          });
          _this5.selectProductList = _.remove(_this5.selectProductList, function (o) {
            return o.optionId != item.optionId;
          });
        });
      }
      //移除过以后需要重新 获取一下当前页，要不然无法连续移除
      // let newlist = _.cloneDeep(this.productList)
      this.crrentPageProductList = this.productList.slice((this.queryParam.page - 1) * this.queryParam.size, (this.queryParam.page - 1) * this.queryParam.size + this.queryParam.size);
      //如果商品list为 0 那么需要把分页的页码重置
      if (this.productList.length == 0) {
        this.queryParam.page = 1;
      }
      this.listTotal = this.productList.length;
      this.selectedRowKeys = [];
      this.selectNumber = 0;
      this.removeTypeVisible = false;
    },
    resetFormDate: function resetFormDate() {
      this.removeTypeVisible = false;
    },
    //批量设置按钮
    removeClick: function removeClick(type) {
      this.buttonType = type;
      if (type == 0) {
        this.dialogStatus = 'batchoff';
        this.modalValue.discount = '';
      } else if (type == 1) {
        this.dialogStatus = 'batchnumber';
        this.modalValue.productNum = '';
      } else {
        this.dialogStatus = 'batchinvalid';
      }
      this.modalValue.removeType = 0;
      this.removeTypeVisible = true;
    },
    tableChange: function tableChange(pagination, filters, sorter, _ref) {
      var currentDataSource = _ref.currentDataSource;
      this.sortedInfo = sorter;
      if (sorter.columnKey) {
        if (typeof sorter.order == "undefined") {
          sorter.order = "ascend";
        }
        if (sorter.order == "ascend") {
          this.productList = _.orderBy(this.productList, ['productStatus'], ['asc']);
        } else {
          this.productList = _.orderBy(this.productList, ['productStatus'], ['desc']);
        }
      }
      this.queryParam.page = pagination.current;
      this.queryParam.size = pagination.pageSize;
      // this.productList = this.productList.filter(item => item.activityProductStatus == 0)
      // let nodeleteList = this.productList.filter(item => item.activityProductStatus == 0)
      console.log(this.productList, 'nodele');
      //初始肯定是第一页，那么需要截取第一页的数据
      this.crrentPageProductList = this.productList.slice((this.queryParam.page - 1) * this.queryParam.size, (this.queryParam.page - 1) * this.queryParam.size + this.queryParam.size);
      console.log(this.crrentPageProductList, 'fenye', this.queryParam.page);
    },
    addProduct: function addProduct() {
      var _this6 = this;
      this.$nextTick(function () {
        _this6.$refs.selectModal.visible = true;
      });
    },
    saveActivity: function saveActivity() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              console.log(_this7.saveList, 'length');
              if (!(_this7.chooseproductparam.productType == 1 && _this7.productList.length == 0)) {
                _context.n = 1;
                break;
              }
              _this7.$message.warning(_this7.$t('activity.warning'));
              _context.n = 5;
              break;
            case 1:
              // 指定商品参加
              _this7.getSaveDataNew();
              params = {
                id: _this7.activityId,
                productType: _this7.chooseproductparam.productType,
                productList: _this7.saveList,
                buyLimit: 0,
                activityContent: 0
              };
              _this7.updateLoading = true;
              // this.basicInformation.nameList = this.basicInformation.multilingualList,
              //第一版是 单品打折全部商品和指定不参加 不需要 设置参与件数
              // productNum: this.addProductIds,
              // this.basicInformation.activityContent = this.chooseproductparam.activityContent,
              // this.basicInformation.buyLimit = this.chooseproductparam.buyLimit,
              // this.basicInformation.buyLimitNum = this.chooseproductparam.buyLimitNum,
              _context.p = 2;
              console.log(_this7.saveList, 'old22222222222222222');
              _context.n = 3;
              return updateActivityPouduct(params);
            case 3:
              res = _context.v;
              if (res.data.code == 200) {
                _this7.getList();
                _this7.$message.success(_this7.$t('public.saveSuccessfully'));
              }
            case 4:
              _context.p = 4;
              _this7.updateLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[2,, 4, 5]]);
      }))();
    },
    nextStep: function nextStep() {
      if (this.chooseproductparam.productType == 1 && this.productList.length == 0) {
        this.$message.warning(this.$t('activity.warning'));
      } else {
        var ProductParamInfo = {
          productType: this.chooseproductparam.productType,
          productList: this.productList.map(function (item) {
            return item.key;
          })
        };
        this.$emit('nextStep', ProductParamInfo);
      }
    },
    // getVisible(visible) {
    // 	this.visible = visible;
    // },
    getProductkeylist: function getProductkeylist(addProductKeyList) {},
    /* 添加按钮 */addNewProduct: function addNewProduct() {
      this.visible = true;
    },
    /* 操作上的移除 */confirm: function confirm(record) {
      //将这条记录从商品list 中移除
      this.saveList.forEach(function (item, index, array) {
        if (item.optionId == record.optionId) {
          array[index].activityProductStatus = 1;
        }
      });
      this.productList = this.saveList.filter(function (item) {
        return item.activityProductStatus == 0;
      });
      this.alreadySelect = this.productList.map(function (item) {
        return item.optionId;
      });
      // 计算删除后  是不是需要换页
      var totalpage = Math.ceil(this.productList.length / this.queryParam.size);
      this.queryParam.page = this.queryParam.page > totalpage ? totalpage : this.queryParam.page;
      this.queryParam.page = this.queryParam.page < 1 ? 1 : this.queryParam.page;
      //移除过以后需要重新 获取一下当前页，要不然无法批量设置值
      this.crrentPageProductList = this.productList.slice((this.queryParam.page - 1) * this.queryParam.size, (this.queryParam.page - 1) * this.queryParam.size + this.queryParam.size);
      this.listTotal = this.productList.length;
      // this.$message.success(this.$t('public.deleteSuccessfully'));
    },
    /* 切换商品范围 */rangetypeChange: function rangetypeChange() {
      //如果切换了商品范围，那么原来失效的商品ids 清空
      this.deleteProductIds = [];
      if (this.chooseproductparam.productType == 1) {
        this.productList = _.cloneDeep(this.yesAvailableList);
      } else if (this.chooseproductparam.productType == 2) {
        this.productList = _.cloneDeep(this.notAvailableList);
      }
      //总条数清空
      this.listTotal = this.productList.length;
      //折扣清空
      this.chooseproductparam.activityContent = '';
      // this.$refs.rangeRuleForm.validateField(["activityContent"])
    },
    cancel: function cancel(e) {
      // this.$message.error(this.$t('public.cancelSuccessfully'));
    },
    getSaveDataNew: function getSaveDataNew() {
      var _this8 = this;
      this.saveList = this.saveList.map(function (item) {
        return {
          id: item.id,
          activityId: _this8.activityId,
          optionId: item.optionId,
          activityProductStatus: item.activityProductStatus,
          productNum: 0,
          activityContent: 0,
          lastUpdateTime: item.lastUpdateTime
        };
      });
    },
    // type:弹窗中数据的4种情况 详见商品弹窗组件内注释  data:传递的数据
    confirmProduct: function confirmProduct(data) {
      var _this9 = this;
      console.log(data, 'getdata');
      this.originalList.forEach(function (item, index, arr) {
        arr[index].activityProductStatus = 1;
      });
      console.log(this.saveList, '11111111111111');
      var addlist = [];
      this.alreadySelect = [];
      this.productList = [];
      data.forEach(function (item, index, arr) {
        // let oldOneindex = this.saveList.findIndex(item3 => item3.optionId == item.optionId)
        // 如果存在 说明有以前的数据匹配上
        if (_this9.originalMap.has(item.optionId)) {
          var index2 = _this9.originalMap.get(item.optionId).myindex;
          _this9.originalList[index2].activityProductStatus = 0;
          _this9.productList.push(_this9.originalList[index2]);
        } else {
          item.activityProductStatus = 0;
          item.id = null;
          item.lastUpdateTime = null;
          // 这种情况是新增的
          addlist.push(item);
          _this9.productList.push(item);
        }
        _this9.alreadySelect.push(item.optionId);
      });
      // let map = new Map()
      // this.saveList = this.saveList.filter(item => !map.has(item.optionId) && map.set(item.optionId,item))
      this.saveList = [].concat(_toConsumableArray(this.originalList), addlist);
      // 拿到的是差集的数据
      // let newlist = _.cloneDeep(this.productList)
      // this.productList = this.saveList.filter(item => item.activityProductStatus == 0)
      // this.alreadySelect = this.productList.map(item => item.optionId)
      this.listTotal = this.productList.length;
      this.crrentPageProductList = this.productList.slice(0, this.queryParam.size);
      console.log(this.crrentPageProductList, 'current');
    }
  }
};